import { z } from 'zod'

export const DisableTwoFactorDTO = z.object({
  password: z.string().min(6).max(60),
  revoke_other_sessions: z.boolean().optional()
})

export type DisableTwoFactorDTO = z.infer<typeof DisableTwoFactorDTO>

export function mapDisableTwoFactorToDTO (
  password: string,
  revokeOtherSessions?: boolean
): DisableTwoFactorDTO {
  return {
    password,
    revoke_other_sessions: revokeOtherSessions !== undefined ? revokeOtherSessions : undefined
  }
}
